import { ReactNode } from 'react';

import { useIntl } from 'react-intl';

interface IInfoBoxProps {
  title: string;
  description: string;
  content?: ReactNode;
  dataTestId?: string;
}

const InfoBox = ({ title, description, content, dataTestId }: IInfoBoxProps) => {
  const intl = useIntl();
  return (
    <div data-test={dataTestId} className="h-100 overflow-hidden d-flex justify-content-center">
      <div className="info-box" style={{ maxWidth: '80%' }}>
        <p className="text-lg font-weight-bold text-blue text-center">
          {intl.formatMessage({ id: title })}
        </p>
        <p style={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}>
          {intl.formatMessage(
            { id: description },
            {
              b: (chunks) => <strong>{chunks}</strong>
            }
          )}
        </p>
        <div className="d-flex justify-content-center">{content}</div>
      </div>
    </div>
  );
};

export default InfoBox;
